import React from 'react';
import { Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { DownloadMode } from '@core/@models/ApiManualModel';

interface ModeToggleProps {
  mode: DownloadMode;
  onChange: (mode: DownloadMode) => void;
}

export const ModeToggle: React.FC<ModeToggleProps> = ({ mode, onChange }) => {
  useTranslation();

  return (
    <div className="mode-toggle">
      <Radio.Group
        value={mode}
        onChange={(e) => onChange(e.target.value)}
        buttonStyle="solid"
      >
        <Radio.Button value="direct">Direct Mode</Radio.Button>
        <Radio.Button value="config">Config Mode</Radio.Button>
      </Radio.Group>
    </div>
  );
};
